import { Component, OnInit } from '@angular/core';
import { Ticketview } from './ticketview';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { TicketviewService } from './ticketviewService';
import { Machine } from '../machine/machine';
import { environment } from 'src/environments/environment';
import { Comment } from '../comment/comment';
import { Status } from '../status/status';
import { Attachment } from '../attachment/attachment';
import { StatusService } from '../status/statusService';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { UserService } from '../_services';
import { User } from '../user/user';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import htmlToPDFmake from 'html-to-pdfmake';
import { Logo } from './logo';
import { Logevent } from '../logevent/logevent';
import { LogEventService } from '../logevent/logeventservice';
pdfMake.vfs = pdfFonts.pdfMake.vfs;


@Component({
  selector: 'app-ticketview',
  templateUrl: './ticketview.component.html',
  styleUrls: ['../app.component.less', './ticketview.component.less']
})

export class TicketviewComponent implements OnInit {

  //#region  VARIABLES
  public Editor = ClassicEditor;
  public model = {
    name: 'John',
    surname: 'Doe',
    description: '<p>A <b>really</b> nice fellow.</p>'
  };
  received: boolean = false;
  saved: boolean = false;
  public ticketdetails = "";
  tickets: Ticketview[];
  public ticket = new Ticketview;
  machine = new Machine;
  newcomment = new Comment;
  comments: Comment[];
  ticketviewurl = environment.graphURL;
  status = new Status;
  attachments: Attachment[];
  _selectedstatusid: number = 1;
  _statuses: Status[];
  ff: any;
  _currentUser: User;
  assignedUser: User;
  csUsers: User[];
  globalreturn: string;
  isAdmin = true;
  public tempId = 0;
  ii = 0;
  public NARR = { content: [] };
  public ARRR = new Array<any>();
  public addstuff: any;
  public OMG: string;
  public detailsIsDisabled = true;
  public resolutionIsDisabled = true;
  public sample: string;
  history: Logevent[];
  isHistoryHidden: boolean = false;
  // Changes Tracking Update
  public tempTicket: Ticketview;
  //#endregion
  ready = false;

  // SHOW-HIDE HISTORY SECTION
  toggleHistory() {
    this.isHistoryHidden = !this.isHistoryHidden;
  }

  public commentconfig = {
    toolbar: {
      items: [
        'heading',
        '|',
        'bold',
        'italic',
        'link',
        'bulletedList',
        'numberedList',
        '|',
        'outdent',
        'indent',
        '|',
        'blockQuote',
        'insertTable',
        'undo',
        'redo',
        //   'alignment' // <--- ADDED 
      ]
    },
    table: {
      contentToolbar: [
        'tableColumn',
        'tableRow',
        'mergeTableCells',
        //  'tableCellProperties', // <--- ADDED 
        // 'tableProperties' // <--- ADDED 
      ]
    },
    // This value must be kept in sync with the language defined in webpack.config.js.
    language: 'en'
  };

  // CLASS CONSTRUCTOR
  constructor(private http: HttpClient,
    private route: ActivatedRoute,
    private ticketviewservice: TicketviewService,
    private statusservice: StatusService,
    private userservice: UserService,
    private logeventservice: LogEventService) {
  }

  // Disable/Enable Text Input
  toggleDisabledDetail() {
    this.detailsIsDisabled = !this.detailsIsDisabled;
  }

  toggleDisabledResolution() {
    this.resolutionIsDisabled = !this.resolutionIsDisabled;
  }

  endisDetail() {
    this.toggleDisabledDetail();
  }

  endisResolution() {
    this.toggleDisabledResolution();
  }

  // ON INIT FUNCTION 
  async ngOnInit() {
    this._currentUser = this.userservice.getCurrentUserFromCookie();
    if (this._currentUser.privilege == "3") { this.isAdmin = false }
    const id = +this.route.snapshot.paramMap.get('id');
    await this.ticketviewservice.getTicketviewGraphQl(id)
      .subscribe(result => {
        this.ticket = JSON.parse(JSON.stringify(result));
        this.tempTicket = JSON.parse(JSON.stringify(result));
        this.machine = this.ticket.machines;
        this.comments = this.ticket.comments.reverse();
        for (var i = 0; i < this.comments.length; i++) {
          this.comments[i].config = {
            toolbar: { items: ['bold', 'undo', 'redo',] }
          };
        }
        this.status = this.ticket.status;
        this._selectedstatusid = this.status.id;
        this.attachments = this.ticket.attachments;
        this.ticketdetails = this.ticket.details;
      });
    await this.logeventservice.getLogByTicket(id).subscribe(resp => this.history = resp.reverse());
    await this.statusservice.getStatuses().subscribe(statuses => this._statuses = statuses);
    await this.userservice.getCSUsers(this._currentUser.client.id).subscribe(response => { this.csUsers = response; });
    this.ready = true;
  }

  // Get Image from URL FUNCTION 
  toDataURL(url, callback, index) {
    var xhr = new XMLHttpRequest();
    let ret: string = "";
    xhr.onload = async () => {
      var reader = new FileReader();
      reader.onloadend = () => {
        callback(reader.result);
        this.OMG = reader.result.toString();
        this.ARRR[this.ii] = {
          content:
            [{
              table: {
                widths: ['*'],
                body: [
                  [{

                    alignment: 'center',
                    image: reader.result.toString(),
                    width: 400,
                    margin: [20, 20, 20, 20]
                  }],
                  [
                    { alignment: 'center', text: "\n Image " + (index + 1) + "  \n\n" }
                  ],

                ]
              }
            },
            { alignment: 'center', text: "\n \n" }
            ]
        };
        this.NARR.content.push(this.ARRR[this.ii].content);
        ret = reader.result.toString();
      }
      reader.readAsDataURL(xhr.response);
    };
    try {
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    }
    catch { }
  }


  // UPLOAD FILE FUNCTION
  onFileChanged(event) {
    const file = event.target.files[0];
    var reader = new FileReader();
    reader.onload = (event: any) => {
      var im = document.getElementById("AV");
      im.setAttribute('src', event.target.result);
      this.ff = event.target.result;
    }

    reader.readAsDataURL(event.target.files[0]);
  }

  // Get TICEKT VIEW BY ID
  getTicketviewById(id: number) {
    this.ticketviewservice.getTicketview(id).subscribe(ticket => this.ticket = ticket);
  }

  // SAVE CHANGES TO TICKET 
  async save() {
    try {
      this.ticket.status.id = this._selectedstatusid;
      if (this.isChangedDeep(this.tempTicket, this.ticket)) {
        await this.ticketviewservice.changeState(this.ticket.id, this._selectedstatusid, this.ticket.details, this.ticket.resolution, this.ticket.assigned_to.id).subscribe(resp => {
          // CHECK IF DETAILS WERE CHANGED 
          if (this.tempTicket.details == resp.details) {
          }
          else {
            this.logeventservice.logEventDo(this._currentUser.id, "Save Changes",
              {
                button: 'Save',
                page: 'TicketView  Ticket:' + this.ticket.id,
                result: 'Success',
                change: 'Details',
                value: this.tempTicket.details
              }, this.ticket.dispatchorder?.id ?? null, this.ticket.id);
          }
          // CHECK IF ASSIGNED USER IS CHANGED
          if (this.tempTicket.assigned_to.id != resp.assigned_to.id) {
            this.logeventservice.logEventDo(this._currentUser.id, "Save Changes",
              {
                button: 'Save',
                page: 'TicketView : Resolved State :  Ticket:' + this.ticket.id,
                result: 'Success',
                change: 'Assigned Tech',
                value: this.tempTicket.assigned_to.username
              }, this.ticket.dispatchorder?.id ?? null, this.ticket.id);
          }
          // CHECK IF RESOLUTION WAS CHANGED 
          if (this.tempTicket.resolution == resp.resolution) {
          }
          else {
            this.logeventservice.logEventDo(this._currentUser.id, "Save Changes",
              {
                button: 'Save',
                page: 'TicketView : Resolved State :  Ticket:' + this.ticket.id,
                result: 'Success',
                change: 'Resolution',
                value: this.tempTicket.resolution,
              }, this.ticket.dispatchorder?.id ?? null, this.ticket.id);
          }
          // CHECK IF STATUS WAS CHANGED 
          if (this.tempTicket.status.id == resp.status.id) {
          }
          else {
            // LOG EVENT DISPATCH CREATE
            this.logeventservice.logEventDo(this._currentUser.id, "Save Changes",
              {
                button: 'Save',
                page: 'TicketView  Ticket:' + this.ticket.id,
                result: 'Success',
                change: 'Status',
                value: this.tempTicket.status.status + "=>" + resp.status.status
              }, this.ticket.dispatchorder?.id ?? null, this.ticket.id);
          }

          window.alert("Changes Saved!");
          this.ngOnInit();
        });

      }
      else {
        window.alert("No changes to be made.");
      }
    }
    catch (error) {
      console.log(error);
    }



  }

  // EXPORT AND CREATE PDF DOCUMENT 
  onExportClick_1() {

    this.ii = 0;
    this.NARR = { content: [] }; // REINITIALIZE ATTACHMENT ARRAY
    var i = 0;
    var myFunc01 = () => {
      while (i < this.ticket.attachments.length) {
        ((i) => {
          setTimeout(() => {  // GIVE A TIMEOUT TO FETCH THE ATTACHEMENTS
            this.ii = i;
            try {
              if ((this.ticket.attachments[i].data.includes("png")) ||
                (this.ticket.attachments[i].data.includes("jpg"))
                || (this.ticket.attachments[i].data.includes("jpeg"))) {
                this.toDataURL(this.ticket.attachments[i].data, () => { }, i);
              }
            }
            catch { };
          }, (1000 * i + 1))
        })(i++);;
      }
    };
    myFunc01();
    setTimeout(() => {
      this.newSaveFnc();
    }, (i + 1) * 1000); // WAIT UNTILL ALL ATTACHMENTS ARE FETCHED
  }

  // ASYNC GET ATTACHMENTS WAITS FOR PROMISE TO BE RETURNED
  async getATTS(): Promise<void> {
    this.ii = 0;
    this.NARR = { content: [] }; // REINITIALIZE ATTACHMENT ARRAY

    let promises = this.ticket.attachments.map((attachment, i) => {
      return new Promise<void>((resolve, reject) => {
        try {
          //console.log("Processing attachment index:", i);
          if (attachment.data.includes("png") ||
            attachment.data.includes("jpg") ||
            attachment.data.includes("jpeg")) {

            this.toDataURL(attachment.data, () => {
              //console.log("Attachment processed:", i);
              resolve(); // Resolve when done
            }, i);
          } else {
            resolve(); // Skip non-image attachments
          }
        } catch (error) {
          console.error("Error processing attachment:", error);
          reject(error);
        }
      });
    });

    await Promise.all(promises); // Wait for all attachments to be processed
  }

  // NEW EXPORT CLICK FUNCTION WAITS FOR GET ATTACHEMENTS TO FINISH
  async onExportClick() {
    try {
      //console.log("Starting export...");
      await this.getATTS(); // Wait for getATTS() to finish
     // console.log("getATTS completed, now calling newSaveFnc...");
      await this.newSaveFnc(); // Wait for newSaveFnc() to finish
     // console.log("Export process completed.");
    } catch (error) {
      console.error("Error during export:", error);
    }
  }


  // UPDATED SAVE FUNCTION THAT GENERATES THE PDF REPORT
  newSaveFnc() {
    var pdfmake = pdfMake;
    this.save();
    var lg: Logo;
    lg = new Logo;
    var strlg: string;
    var clname: string;
    var wdth: number;

    // IF USER IS INFOTEC USER THEN USE INFOTEC LOGO / LETTERHEAD
    if (this._currentUser.client.id == 3) {
      strlg = lg.versystech();
      clname = this.machine.location.addr1;
      wdth = 100;
    }

    // IF USER IS CSG, USE CSG LOGO AND LETTERHEAD 
    else {
      strlg = lg.versystech();
      clname = this.ticket.machines.client.name;
      wdth = 110;
    }
    // IF NO RESOLUTION IS WRITTEN THEN INITIALIZE THE OBJECT
    if (this.ticket.resolution == null) {
      this.ticket.resolution = " "
    }

    var pdfcontent = htmlToPDFmake(this.ticket.details);
    var pdfresolution = htmlToPDFmake(this.ticket.resolution);

    // TABLES FORMATTING FOR CUSTOMER DETAILS
    const customerDetailsData = [[{ style: 'mycell', text: 'Customer' }, { style: 'bigger', text: clname + '\n' },
    { style: 'mycell', text: 'Report' }, { style: 'bigger', text: '#: ' + this.ticket.id + '\n' }],
    [{ style: 'mycell', text: 'Contact' }, this.machine.location.contact_name, { style: 'mycell', text: 'Add1' }, this.machine.location.addr1],
    [{ style: 'mycell', text: 'Phone' }, this.machine.location.phone_number, { style: 'mycell', text: 'City' }, this.machine.location.City],
    [{ style: 'mycell', text: 'Email' }, this.machine.location.email, { style: 'mycell', text: 'Country' }, this.machine.location.Country],
    ];

    // TABLES FORMATTING FOR TICKET DETAILS
    const ticketInfoData = [[{ style: 'mycell', text: 'Title' }, { style: 'bigger', text: this.ticket.title + '\n' },
    { style: 'mycell', text: 'ERR_Code' }, { style: 'bigger', text: '#: ' + this.ticket.errorcode + '\n' }],
    [{ style: 'mycell', text: 'Status' }, this.ticket.status.status, '', ''],
    [{ style: 'mycell', text: 'Posted By' }, this.ticket.user.username, { style: 'mycell', text: 'Date Posted' }, this.ticket.dateofticket],
    [{ style: 'mycell', text: 'Assigned To' }, this.ticket.assigned_to.firstname + " " + this.ticket.assigned_to.lastname,
    { style: 'mycell', text: 'Date Update' }, this.ticket.dateresolved.substring(0, 10)],
    ];

    // TABLES FORMATTING FOR MACHINE DETAILS
    const machineInfoData = [[{ style: 'mycell', text: 'Asset' }, { style: 'bigger', text: this.machine.shortname + '\n' },
    { style: 'mycell', text: 'Serial No' }, { style: 'bigger', text: '#: ' + this.machine.serialnumber + '\n' }],
    [{ style: 'mycell', text: 'Model' }, this.machine.machinetype.type, { style: 'mycell', text: 'State' }, this.machine.state.statevalue],
    [{ style: 'mycell', text: 'Counter' }, this.machine.counter, '', '']
    ];

    // TABLES FORMATTING FOR TICKET DETAILS & RESOLUTION
    const pdfcontTable = [[{ style: 'mycell', text: 'Details' }],
    [pdfcontent]
    ];

    const pdfresTable = [[{ style: 'mycell', text: 'Resolution' }],
    [pdfresolution]
    ];


    // TABLES FORMATTING FOR SIGNATURE FOOTER
    const sigTable = [
      [{ style: 'mycell', text: 'Technician Name' }, this.ticket.assigned_to.firstname + ' ' + this.ticket.assigned_to.lastname, { style: 'mycell', text: 'Customer Name' }, this.machine.location.contact_name],
      [{ style: 'mycell', text: 'Signature\n' }, '', { style: 'mycell', text: 'Signature\n' }, '']];


    // ARRAY FOR BUILDING PDF DOCUMENT  
    const documentHeader = { // PDF DOCUMENT HEADER AS ARRAY
      content:
        [
          {
            image: strlg,
            width: wdth
          },
          { style: 'header', alignment: 'center', text: 'Service Report \n\n' },
          ,
          { style: 'bigger', text: 'Customer Details' },
          { table: { widths: [75, 250, 75, 75], body: customerDetailsData } },

          { style: 'bigger', text: '\nTicket Information' },
          { table: { widths: [75, 250, 75, 75], body: ticketInfoData } },
          { style: 'bigger', text: '\nAsset Info' },
          { table: { widths: [75, 250, 75, 75], body: machineInfoData } },
          { text: '\n' },
          { table: { widths: [500], body: pdfcontTable } },
          { text: '\n' },
          { table: { widths: [500], body: pdfresTable } },
          { text: '\n\n\n' },
        ]
    };

    const documentFooter = { // PDF DOCUMENT FOORER AS ARRAY      
      content: [
        {
          absolutePosition: { x: 40, y: 750 },
          table: { widths: [100, 135, 100, 135], heights: [20, 40], body: sigTable }
        },
      ],
    };

    // DOCUMENT DEFAULT CONFIGURATION 
    const def = {
      defaultStyle: {
        fontSize: 11,
        columnGap: 0,

      }
    };
    // DOCUMENT STYLES ADDITION 
    const stl = {
      styles:
      {
        header: {
          fontSize: 14,
          bold: true,

        },
        mycell: {
          fillColor: '#ECECEC',
          width: 700
        },

        bigger: {
          fontSize: 11,
          bold: true
        }
      }
    };

    // DOCUMENT CREATION AND ADDITION OF STYLES AND CONTENT
    var pubz = { content: [], styles: {}, defaultStyle: {} };
    pubz.styles = stl.styles;
    pubz.defaultStyle = def.defaultStyle;

    // IF TICKET HAS ATTACHEMENTS INCLUDE THE ATTACHMENTS IN REPORT
    if (this.ticket.attachments.length > 0) {
      const documentAtt = {
        content: [
          { style: 'bigger', text: 'Attachments \n\n', pageBreak: 'before' },
          this.NARR.content,
        ]
      };
      pubz.content.push(documentHeader.content);
      pubz.content.push(documentFooter.content);
      pubz.content.push(documentAtt.content);

    }
    // NO ATTACHEMENTS IN THE TICKET
    else {
      pubz.content.push(documentHeader.content);
      pubz.content.push(documentFooter.content);
    }
    pdfmake.createPdf(pubz).open();
  }

  //CHECK CHANGES
  getChangedAttributes(obj1, obj2) {
    let changes = {};

    function isChangedDeep(value1, value2) {
      if (value1 === value2) return false; // Same reference, no change
      if (typeof value1 !== "object" || typeof value2 !== "object" || value1 === null || value2 === null) {
        return String(value1) !== String(value2); // Handle type mismatches
      }

      const keys1 = Object.keys(value1);
      const keys2 = Object.keys(value2);

      if (keys1.length !== keys2.length) return true; // Different number of keys

      for (let key of keys1) {
        if (!value2.hasOwnProperty(key) || isChangedDeep(value1[key], value2[key])) {
          return true; // Recursive check
        }
      }
      return false;
    }

    for (let key in obj1) {
      if (obj1.hasOwnProperty(key)) {
        if (!obj2.hasOwnProperty(key)) {
          changes[key] = { oldValue: obj1[key], newValue: undefined };
        } else if (isChangedDeep(obj1[key], obj2[key])) {
          changes[key] = { oldValue: obj1[key], newValue: obj2[key] };
        }
      }
    }

    for (let key in obj2) {
      if (obj2.hasOwnProperty(key) && !obj1.hasOwnProperty(key)) {
        changes[key] = { oldValue: undefined, newValue: obj2[key] };
      }
    }

    return changes;
  }
  // RETURNS TRUE IF CHANGES OR FALSE IF NOT
  isChangedDeep(objA, objB) {
    if (objA === objB) return false; // Same reference, no change

    if (typeof objA !== "object" || typeof objB !== "object" || objA === null || objB === null) {
      return objA !== objB; // Direct comparison for primitive values
    }

    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);

    if (keysA.length !== keysB.length) return true; // Different number of keys

    for (let key of keysA) {
      if (!objB.hasOwnProperty(key)) return true; // Key missing in objB

      if (typeof objA[key] === "object" && typeof objB[key] === "object") {
        if (this.isChangedDeep(objA[key], objB[key])) return true; // Recursive check for nested objects
      } else if (String(objA[key]) !== String(objB[key])) {
        return true; // Handle type mismatches like 122 vs. "122"
      }
    }

    return false; // No differences found
  }
}
